export default {
  methods: {
    // TO MIXIN
    paginationHandler () {
      const table = this.$refs.table

      if (table) {
        table.onscroll = () => {
          const { scrollTop, scrollHeight, clientHeight } = table
          let bottom = scrollTop + clientHeight >= scrollHeight - 24

          if (bottom && this.currentPage < this.lastPage) {
            this.nextPage()
          }
          // let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight >= document.documentElement.offsetHeight
          // let bottomOfWindow = (window.innerHeight + window.pageYOffset) >= document.body.offsetHeight
          // if (bottomOfWindow && this.currentPage < this.lastPage) {
          //    this.nextPage()
          // }
        }
      }
    }
  },
  mounted () {
    this.paginationHandler()
  }
}
